import React from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import PrimaryButtonWithIconAdd from '../../../components/ui/PrimaryButtonWithIconAdd';
import EmptyData from '../../../components/ui/EmptyData';
import { useGiftCategoriesByAdmin } from '../../../hooks/admin/giftCategory.admin';
import GiftCategoryListTable from '../../../components/admin/giftCategories/GiftCategoryListTable';
import { PermissionGate } from '../../../components/admin/PermissionGate';
import { PermissionsKey } from '../../../data/permissions';

function AdminViewGiftCategoriesPage() {
    const {t} = useTranslation();
    
  const {data:gifts,isLoading,isError} = useGiftCategoriesByAdmin();
  return (
    <Layout title={t('admin_sidebar.gift_catgeories')} headline=''>
        <div className='flex justify-end'>
            <PermissionGate permissions={[PermissionsKey.CreateGiftCategory]}>
              <PrimaryButtonWithIconAdd
              buttonLabel="add_new_gift_category"
              buttonLinkPath={`/admin/add-giftCategory`}
              />
            </PermissionGate>
         </div>
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        />
         {
        gifts && (
          gifts.length === 0 ?<EmptyData/> : <GiftCategoryListTable gifts={gifts}/>
        )
        }
    </Layout>
  )
}

export default AdminViewGiftCategoriesPage   